import { render } from "./achievementsTab.vue?vue&type=template&id=d4d6c688&scoped=true"
import script from "./achievementsTab.vue?vue&type=script&lang=js"
export * from "./achievementsTab.vue?vue&type=script&lang=js"

import "./achievementsTab.vue?vue&type=style&index=0&id=d4d6c688&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d6c688"]])

export default __exports__